
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { RestApi } from '../../../auth/rest.api';

const baseApiBexUrl = 'api/BEX/';

@Injectable()
export class DeploymentService {

  constructor(
    private _authHttp: RestApi
  ) { }

  upload(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this._authHttp
      .postFile(baseApiBexUrl + 'Import', formData);
  }

  getLoadStatus(uploadID: string) {
    return this._authHttp.get(baseApiBexUrl + 'GetStateImport/' + uploadID);
  }

  getCurrentBEX(): Observable<ICurrentBexFromServer> {
    return this._authHttp.get(baseApiBexUrl + 'GetCurrentBEX');
  }

  getStatusCurrentBEX(): Observable<ICurrentBexFromServer> {
    return this._authHttp.get(baseApiBexUrl + 'GetCurrentStatus');
  }

  getHistory() {
    return this._authHttp.get(baseApiBexUrl + 'GetHistoryLoaded');
  }

  downloadTraceFile(bexId: string) {
    return this._authHttp.requestBlob({ url: `${baseApiBexUrl}/Download/${bexId}`, parameters: [], body: {} }, 'GET');
  }

  getPackageSummary(packageId: string): Observable<IPackageSummary> {
    return this._authHttp.get(`${baseApiBexUrl}/PackageSummary/${packageId}`);
  }

  getPackageSummaryEncrypt(id: string, password: string): Observable<IPackageSummary> {
    return this._authHttp.post(`${baseApiBexUrl}/PackageSummary`, { id, password});
  }

  getPackageVisualizerDependencies(packageId: string, objectId: string) {
    return this._authHttp.get(baseApiBexUrl + `/TraceDependencies/${packageId}/${objectId}`);
  }

  getMaintenanceWindowReasons() {
    return this._authHttp.get(baseApiBexUrl + 'MaintenanceWindowReasons');
  }

  applyBexUpload(forceWorkspaceMigration: boolean) {
    return this._authHttp.post(baseApiBexUrl + 'Apply', {forceWorkspaceMigration});
  }

  showWorkspaceMigrationObject() {
    return this._authHttp.get(baseApiBexUrl + 'ShowWorkspaceMigrationObject');
  }

  getImportStatus() {
    return this._authHttp.get(baseApiBexUrl + 'Import');
  }

  cancelBexImport() {
    return this._authHttp.delete(baseApiBexUrl + 'Cancel');
  }

  decryptBex(password: string) {
    return this._authHttp.put(baseApiBexUrl + 'Password', { password });
  }

  checkBexEncrypt(packageId?: string) {
    const url = packageId != null ? `IsEncrypted/${packageId}` : 'IsEncrypted'
    return this._authHttp.get(baseApiBexUrl + url);
  }

  getDelta(packageId: string) {
    return this._authHttp.get(baseApiBexUrl + `/DeltaSummary/${packageId}`);
  }

  downloadDeltaReport(packageId: string, objectsToInclude: string[]) {
    return this._authHttp.requestBlob(
      { url: `${baseApiBexUrl}/DeltaReport/${packageId}`, parameters: [], body: objectsToInclude },
      'POST'
    );
  }

  getEnableViewDelta(): Observable<boolean> {
    return this._authHttp.get(baseApiBexUrl + 'EnableViewDelta');
  }

  getDeltaBasicTypes(): Observable<string[]> {
    return this._authHttp.get(baseApiBexUrl + 'GetDeltaBasicTypes');
  }

}
